import { connect } from 'react-redux';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';
import GridTileVideoInline from './grid_tile_video_inline.jsx';
import { getContentItemByUuid } from 'zoomforth_codesbane_viewer/reducers/index.js';


const mapStateToProps = (state, props) => {
  const { uuid } = props;

  const contentItem = getContentItemByUuid(state, uuid);

  return { contentItem };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    makeVideoishPlayerTrackingCallbacks: (contentItem) => ({
      onEnded: (eventData) => {
        getTracker().handleInlineVideoEnded(contentItem, eventData);
      },
      onError: (eventData) => {
        getTracker().handleInlineVideoError(contentItem, eventData);
      },
      onPause: (eventData) => {
        getTracker().handleInlineVideoPause(contentItem, eventData);
      },
      onPlay: (eventData) => {
        getTracker().handleInlineVideoPlay(contentItem, eventData);
      },
      onSeeked: (eventData) => {
        getTracker().handleInlineVideoSeeked(contentItem, eventData);
      },
      onStart: (eventData) => {
        getTracker().handleInlineVideoStart(contentItem, eventData);
      },
      onTimeUpdate: (eventData) => {
        getTracker().handleInlineVideoTimeUpdate(contentItem, eventData);
      }
    })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GridTileVideoInline);
